<template>
  <div>
    <v-toolbar dense color="white">
      <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-form ref="form">
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <v-row>
          <v-col cols="5">
            <v-text-field
              :value="parseDisasterName"
              label="災害名称"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="3" lg="2">
            <v-text-field
              :value="emergencyStatusName"
              label="緊急事態区分"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="3" md="3" lg="5">
            <v-textarea
              :value="parsedDeliveryArea"
              label="配信先エリア"
              placeholder=" "
              readonly
              rows="3"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="3" md="3" lg="3">
            <v-text-field
              :value="submitItem.deliveryTitle"
              label="件名"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6">
            <v-textarea
              :value="submitItem.deliveryBody"
              counter="200"
              maxlength="200"
              label="通知文(スマホアプリ(プッシュ通知))"
              :placeholder="' '"
              readonly
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-row>
      <v-col>
        <template>
          <v-btn
            class="mx-2"
            color="primary"
            v-if="hasEditAuth()"
            @click="onClickDuplicate"
          >
            コピーして編集
          </v-btn>
          <v-btn class="mx-2" color="primary" @click="onClickReturn">戻る</v-btn>
        </template>
      </v-col>
    </v-row>

    <select-urls
      ref="selectUrls"
      :isShowSelect="!evacuationOrderScreenMode.isView()"
      :isShowAgreeButton="!evacuationOrderScreenMode.isView()"
    />
    <confirm-dialog ref="confirmSubmit"></confirm-dialog>
    <v-overlay :value="overlay" opacity="0.5" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import ConfirmDialog from "@/components/ConfirmDialog";
import SelectUrls from "@/components/SelectUrls";
import config from "@/js/const";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import Disaster from "@/plugins/disaster";
import { ScreenId } from "@/js/value-objects/screen-id";
import { ScreenCrud } from "@/js/value-objects/screen-crud";
import messageUtils from "@/mixins/message-utils";
import { arrayCount } from "@/js/utils";
import { EvacuationOrderScreenMode } from "@/js/value-objects/evacuation-order-screen-mode";

Vue.use(Disaster);

const disasterDeliveryDetailRepository = RepositoryFactory.get(
  "disasterDeliveryDetail"
);

export default {
  mixins: [messageUtils],
  components: {
    SelectUrls,
    ConfirmDialog,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage")
  },
  props: {
    delivery_no: String
  },
  data: () => ({

    overlay: false,
    evacuationOrderScreenMode: "",
    screenId: "",
    screenTitle: "",
    submitItem: {
      disasterNo: "",
      emergCls: EmergencyClass.NL,
      deliveryArea: [],
      deliveryBody: "",
      deliveryTitle: ""
    },
    uploadDialog: false,
    editedFileItems: [],
    config: config,
    urlCreateFlag: true,
    fixedPhrase: [],
    disasterDeliveryDetail: {},
    disasters: [
      {
        disaster_no: 0,
        disaster_name: ""
      }
    ],
    municipalities: [],
    buttons: [
      { buttonId: "SUBMIT" },
      { buttonId: "TEMPORARILY_SAVED" },
      { buttonId: "DUPLICATE" },
      { buttonId: "CANCEL" }
    ],
    rules: {
      required: value => !!value || "必須項目です。"
    },
    showTempleteDialog: false,
    templateItems: [
      {
        emergency_class: "GE",
        title: "テンプレート",
        contents: "ここには本文が入ります。"
      }
    ]
  }),

  computed: {
    // ボタンの表示テキスト
    buttonText() {
      return function(buttonId) {
        let buttonText = "";
        switch (buttonId) {
          case "SUBMIT":
            buttonText = "送信";
            break;
          case "TEMPORARILY_SAVED":
            buttonText = "一時保存";
            break;
          case "DUPLICATE":
            buttonText = "コピーして編集";
            break;
          case "CANCEL":
            if (!this.evacuationOrderScreenMode.isView()) {
              buttonText = "キャンセル";
            } else {
              buttonText = "戻る";
            }
            break;
          default:
            break;
        }
        return buttonText;
      };
    },
    // ボタンの非活性制御（true：非活性、false：活性）
    isDisabled() {
      return function(buttonId) {
        let disabled = false;
        switch (buttonId) {
          case "SUBMIT":
            if (
              !this.submitItem.disasterNo ||
              !this.submitItem.deliveryTitle ||
              !this.submitItem.deliveryBody
            ) {
              disabled = true;
            }
            break;
          case "TEMPORARILY_SAVED":
            if (!this.submitItem.disasterNo) {
              disabled = true;
            }
            break;
          case "DUPLICATE":
            break;
          case "CANCEL":
            break;
          default:
            break;
        }
        return disabled;
      };
    },

    // 災害名称（参照用）
    parseDisasterName() {
      const disasterItem = this.disasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        return disasterItem.disaster_name;
      } else {
        return "";
      }
    },

    // 緊急事態区分（参照用）
    emergencyStatusName() {
      return EmergencyClass.factory(this.submitItem.emergCls).toName();
    },

    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(false, counter);
      };
    },

    parsedDeliveryArea() {
      const municipArray = [];
      this.municipalities.forEach(obj => {
        this.submitItem.deliveryArea.forEach(municip => {
          if (obj.value === municip) {
            municipArray.push(obj.text);
          }
        });
      });
      return municipArray;
    },

    //通知文
    parsedTextArea() {
      const text = this.submitItem.deliveryBody;
      return text;
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;
      // Set the ID & Screen name
      this.evacuationOrderScreenMode = EvacuationOrderScreenMode.factory(this.$route.name);
      this.screenId = this.evacuationOrderScreenMode.getScreenId();
      this.screenTitle = ScreenId.getScreenTitle(this.screenId);
      this.pageTitle(this.screenTitle);
      this.delivery_no = this.$route.params.delivery_no;

      // 災害情報
      await this.$store
        .dispatch("disasterInfo/loadDisasterInfo", this.evacuationOrderScreenMode.getScreenId())
        .then(() => {
          this.disasters = this.$store.state.disasterInfo.data.results;
        })
        .catch(e => {
          this.handleError(e, this.evacuationOrderScreenMode.getScreenId(), "evacuation-order-management");
        });

      // 市町村
      await this.$store
        .dispatch("allArea/loadAllArea")
        .then(() => {
          this.municipalities = this.$store.state.allArea.municipalities;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });

      // 災害配信情報
      await disasterDeliveryDetailRepository
        .list(this.screenId, this.delivery_no)
        .then(res => {
            this.disasterDeliveryDetail = res.data.results[0];
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });

      // 各値設定
      this.submitItem.disasterNo = this.disasterDeliveryDetail.disaster_no;
      this.submitItem.emergCls = this.disasterDeliveryDetail.emerg_cls;
      if (arrayCount(this.disasterDeliveryDetail.dests) > 0) {
          this.disasterDeliveryDetail.dests.forEach(dest => {
            this.submitItem.deliveryArea.push(dest.municip_code);
          });
        }
      this.submitItem.deliveryTitle = this.disasterDeliveryDetail.delivery_title;
      this.submitItem.deliveryBody = this.disasterDeliveryDetail.delivery_body;
      
      // 緊急事態区分テキストボックス
      const disasterItem = this.disasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        this.submitItem.emergCls = disasterItem.emerg_cls;
      } else {
        this.submitItem.emergCls = EmergencyClass.NL;
      }
      this.overlay = false;
    },

    // ボタン表示制御
    isVisible(buttonId) {
      let visible = false;
      switch (buttonId) {
        case "SUBMIT":
          if (
            this.evacuationOrderScreenMode.isEdit() ||
            this.evacuationOrderScreenMode.isCreate() ||
            this.evacuationOrderScreenMode.isDuplicate()
          ) {
            visible = true;
          }
          break;
        case "TEMPORARILY_SAVED":
          if (
            this.evacuationOrderScreenMode.isEdit() ||
            this.evacuationOrderScreenMode.isCreate() ||
            this.evacuationOrderScreenMode.isDuplicate()
          ) {
            visible = true;
          }
          break;
        case "DUPLICATE":
          if (this.evacuationOrderScreenMode.isView()) {
            if (
              this.$screenOperationAuthority(ScreenId.SF0301, ScreenId.SF0302)
                .readOnly
            ) {
              visible = false;
            } else {
              visible = true;
            }
          }
          break;
        case "CANCEL":
          visible = true;
          break;
        default:
          break;
      }
      return visible;
    },
    // ボタン押下時処理
    async onClick(buttonId) {
      switch (buttonId) {
        case "SUBMIT":
          this.submit();
          break;
        case "TEMPORARILY_SAVED":
        case "CANCEL":
          this.$router.push("/evacuation-order");
          break;
        default:
          break;
      }
    },

    // 編集画面の権限があるかチェック
    hasEditAuth() {
      const editScreenId = ScreenId.SF0308;
      const editAuth = this.$screenAuthority.find(
        auth => auth.screen_id === editScreenId
      );
      if (editAuth) {
        const screenCrud = ScreenCrud.factory(editAuth.screen_crud);
        return screenCrud.isOperation();
      } else {
        return false;
      }
    },

    // コピーして編集ボタン押下時処理
    onClickDuplicate() {
      this.$router.push({
        name: `emergency-mail-duplicate`,
        params: {
          delivery_no: this.delivery_no
        }
      });
    },

    // 戻るボタン押下時処理
    onClickReturn() {
      this.$router.push("/evacuation-order");
    }
  },

  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 10000);
    }
  }
};
</script>

<style scoped>
.list-file-name {
  color: black;
}
</style>
